import { render, staticRenderFns } from "./index3.vue?vue&type=template&id=13f83863&scoped=true&"
import script from "./index3.vue?vue&type=script&lang=js&"
export * from "./index3.vue?vue&type=script&lang=js&"
import style0 from "./index3.vue?vue&type=style&index=0&id=13f83863&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f83863",
  null
  
)

export default component.exports